import 'core-js/es6/map';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import './index.css';
import App from './components/App';
import reducers from './reducers';
import ActionTypes from './constants/actionTypes';
import SHOP_PARAMETER_CODES from './constants/shopParameterCodes';

import { LocalizeProvider } from 'react-localize-redux';
import * as axios from 'axios';
import exchangeShopData from './utils/exchangeShopData';

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(reduxThunk))
);

// intercept backend request and add the code provided by shop for authentification
axios.interceptors.request.use(config => {
  config.headers.Authorization =
    'CUSTOM ' + store.getState().shopParameters.data.code;
  return Promise.resolve(config);
});

function base64Decode(str, encoding = 'utf-8') {
  if (!str || str.length === 0) {
    return '';
  }

  var decoded = Buffer.from(str.trim(), 'base64').toString('ascii');
  decoded = decoded.trim();
  return decoded;
}

function getUrlParameters() {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  var parameters = [];
  for (var i = 0; i < sURLVariables.length; i++) {
    var param = sURLVariables[i];
    var paramIndex = param.indexOf('=');
    parameters[param.substring(0, paramIndex)] = param.substring(
      paramIndex + 1,
      param.length
    );
  }

  var data = {};
  data.code = parseParameter(parameters['code']);
  data.locale = parseParameter(parameters['locale']);
  data.partnerServiceHoursText = base64Decode(
    parseParameter(parameters['partnerServiceHoursText'])
  );
  return data;
}

function parseParameter(parameter) {
  if (!parameter) {
    return '';
  }

  var uriDecoded = decodeURIComponent(parameter);
  uriDecoded = uriDecoded.trim();
  return uriDecoded;
}

function updateShopParameters() {
  var shopParameters = getUrlParameters();

  var resolvedShopParameters = {};
  resolvedShopParameters.locale = shopParameters.locale;
  resolvedShopParameters.code = shopParameters.code;

  if (shopParameters.partnerServiceHoursText) {
    var params = shopParameters.partnerServiceHoursText.split(',');
    if (params && params.length === 1) {
      resolvedShopParameters.serviceHoursLine1 = params[0];
    }
    if (params && params.length === 2) {
      resolvedShopParameters.serviceHoursLine1 = params[0];
      resolvedShopParameters.serviceHoursLine2 = params[1];
    }
  }

  store.dispatch({
    type: ActionTypes.UPDATE[SHOP_PARAMETER_CODES.PARAMETERS],
    payload: resolvedShopParameters
  });

  // TBD: how to move this to redux (while we are outside of the main app (?))
  return exchangeShopData(shopParameters)
    .then(response => {
      response.data.locale = shopParameters.locale;
      response.data.code = shopParameters.code;

      store.dispatch({
        type: ActionTypes.UPDATE[SHOP_PARAMETER_CODES.PARAMETERS],
        payload: response.data
      });
    })
    .catch(error => {
      store.dispatch({
        type: ActionTypes.FAILED2FETCH[SHOP_PARAMETER_CODES.PARAMETERS],
        payload: error
      });
    });
}

updateShopParameters();

ReactDOM.render(
  <Provider store={store}>
    <LocalizeProvider store={store}>
      <App />
    </LocalizeProvider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js